import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import {connect} from "react-redux";
import styles from "./EventGroupDetails.scss";
import Loader from "components/shared/elements/Loader";
import * as SiteActions from "actions/SiteActions";
import Calendar from "components/site/elements/Calendar";
import filter from "lodash/filter";
import map from "lodash/map";
import EventCard from "components/site/elements/EventCard";
import moment from "moment";

function EventGroupDetails(props) {
    const history = useHistory();

    useEffect(() => {
        window.scrollTo(0, 0);
        props.loadPublicEvents(props.eventGroupSlug);
        if(!props.eventGroup) {
            props.loadEventTypes();
        }
    }, [props.eventId]);

    if (!props.events || !props.eventGroup) {
        return <Loader />
    }

    const renderUpcomingEvents = () => {
        // Filter for the upcoming week/month?
        const next10 = map(props.events).slice(0,10);
        return map(next10, (event, indx) => (
            <EventCard event={event} key={`event_${indx}`}/>
        ));
    }

    const handleCalendarClick = (calendarDate) => {
        history.push(`/calendar/${moment(calendarDate).format("YYYY-MM-DD")}`)
    }

    return (
        <div className={styles.root}>
            <div className={styles.root}>
                <div className={styles.content}>
                    <div className={styles.mainContainer}>
                        <div className={styles.topText}>
                            <Link to={"/"}>
                                &lt; Back to All Classes & Events
                            </Link>
                        </div>
                        <div className={styles.groupInfo}>
                            <div className={styles.groupImage} style={{
                                backgroundImage: `url(${props.eventGroup.image})`,
                                borderBottom: `4px solid ${props.eventGroup.eventType.color}`,
                            }}>
                                <div className={styles.groupLogo}>
                                    <img src={props.eventGroup.logo} alt={`${props.eventGroup.name} logo`} />
                                </div>
                            </div>
                            {props.eventGroup.longDescription ? (
                                <p className={styles.description} dangerouslySetInnerHTML={{__html: props.eventGroup.longDescription}} />
                            ):(
                                <p className={styles.description}>{props.eventGroup.description}</p>
                            )}
                        </div>
                        <div className={styles.eventsContainer}>
                            {renderUpcomingEvents()}
                        </div>
                    </div>
                    <div className={styles.sidebarContent}>
                        <div className={styles.sidebarInner}>
                            <div className={styles.topText}>
                                    <Link to={"/"}>
                                        &lt; Back to All Classes & Events
                                    </Link>
                            </div>
                            <Calendar
                                onClick={handleCalendarClick}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(
    (state, ownProps) => {
        const eventGroupSlug = ownProps.match.params.eventGroupSlug;
        const filteredEvents = filter(state.site.events, event => event.eventGroup?.slug === eventGroupSlug);
        const firstEventGroup = filteredEvents[0]?.eventGroup||{};
        const eventGroup = state.site.eventTypes ? {
            ...state.site.eventTypes?.[eventGroupSlug] || {},
            longDescription: firstEventGroup?.longDescription,
        } : null;
        return {
            eventGroupSlug,
            events: filteredEvents,
            eventGroup,
        };
    },
    (dispatch) => ({
        loadPublicEvents: (eventGroupSlug) => dispatch(SiteActions.loadPublicEvents(eventGroupSlug)),
        loadEventTypes: () => dispatch(SiteActions.loadEventTypes()),
    })
)(EventGroupDetails);
